module.exports = __webpack_public_path__ + "img/aeroland-digital-store-product-02.951e5182.jpg";